import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "styled-components";
import { sample, reject } from "lodash";
import { animateScroll as scroll } from "react-scroll";
import ReactPlayer from "react-player";

import mgsLogo from "../../mgs2018logo.svg";
import Blurb from "../Blurb/Blurb";
import Footer from "../Footer/Footer";
1;
import brandImage from "./logo.svg";
import circle from "./communityart.png";

import communityart from "./images/communityart.png";
import curatorial from "./images/curatorial.png";
import filmmaking from "./images/filmmaking.png";
import graphicdesign from "./images/graphicdesign.png";
import hoffburg from "./images/hoffburg.png";
import illustration from "./images/illustration.png";
import maGraphicdesign from "./images/ma-graphicdesign.png";
import maIllustration from "./images/ma-illustration.png";
import mountroyal from "./images/mountroyal.png";
import photo from "./images/photo.png";
import rinehart from "./images/rinehart.png";
import socialdesign from "./images/socialdesign.png";
import studioart from "./images/studioart.png";
import teaching from "./images/teaching.png";

import {
  Wrapper,
  GraphicWrapper,
  Graphic,
  LogoWrapper,
  MicaLogo,
  Rotate,
  Bg,
} from "./styles";
import { colors } from "../../util";

const themes = {
  orange: {
    color: colors.alt.orange,
  },
  blue: {
    color: colors.alt.blue,
  },
  // green: {
  //   color: colors.alt.green,
  // },
  // deepBlue: {
  //   color: colors.alt.deepBlue,
  // },
  pink: {
    color: colors.alt.pink,
  },
};

const imageOptions = {
  communityart,
  curatorial,
  filmmaking,
  graphicdesign,
  hoffburg,
  illustration,
  maGraphicdesign,
  maIllustration,
  mountroyal,
  photo,
  rinehart,
  socialdesign,
  studioart,
  teaching,
};

const videoOptions = [
  "MGS22_1_slow",
  "MGS22_2_slow",
  "MGS22_3_slow",
  "MGS22_4_slow",
  "MGS22_5_slow",
  "MGS22_6_slow",
  "MGS22_7_slow",
  "MGS22_8_slow",
];

const logo = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 805.02 797.09"  >
<style type="text/css">
.st1{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}
</style>
<g>
 <path class="st3" d="M130.28,25.29h-0.16V135.4h-4.95V17.36h7.43l47.38,111.27h0.16l46.72-111.27h7.76V135.4h-5.12V25.29h-0.16
   L182.61,135.4h-5.28L130.28,25.29z"/>
 <path class="st3" d="M337.63,135.4h-5.12V17.36h5.12V135.4z"/>
 <path class="st3" d="M517.42,50.54c-2.81-16.34-16.67-30.38-39.62-30.38c-31.04,0-48.04,24.27-48.04,56.3
   c0,32.69,17.33,55.97,47.55,55.97c25.42,0,39.95-17.83,42.43-39.29h4.79c-0.99,11.39-5.28,21.96-12.55,29.88
   c-7.92,8.75-19.98,14.2-34.67,14.2c-32.36,0-52.99-24.27-52.99-60.75c0-35.66,20.47-60.92,53.49-60.92
   c25.42,0,41.27,15.19,44.9,35H517.42z"/>
 <path class="st3" d="M651.64,95.12H596.5l-15.52,40.28h-5.45L621.1,17.36h5.94L672.6,135.4h-5.45L651.64,95.12z M598.15,90.66
   h51.67l-25.59-67.03h-0.17L598.15,90.66z"/>
</g>
<g>
 <path class="st3" d="M179.47,297.03v-4.62h46.22v58.44h-4.29l-0.5-27.9h-0.33c-3.96,14.53-18.16,29.72-42.76,29.72
   c-35.49,0-54.81-26.25-54.81-60.59c0-33.68,19.32-61.08,54.97-61.08c24.76,0,41.77,13.54,45.89,35.49h-5.12
   c-3.63-18.66-18.82-30.87-40.78-30.87c-33.18,0-49.53,26.25-49.53,56.46c0,31.04,16.51,55.8,49.36,55.8
   c26.91,0,42.76-18.99,42.76-44.9v-5.94H179.47z"/>
 <path class="st3" d="M293.72,350.85h-5.12V232.81h47.22c21.79,0,34.67,11.23,34.67,31.37c0,15.35-7.1,25.59-22.12,29.06v0.16
   c13.54,3.14,18.82,12.88,19.48,30.05c0.66,22.12,2.97,25.42,4.79,26.91v0.5h-5.61c-1.82-1.32-3.8-5.12-4.46-27.4
   c-0.66-19.32-7.92-27.57-26.74-27.57h-42.1V350.85z M293.72,291.09H334c20.97,0,31.2-9.57,31.2-26.74
   c0-17-10.4-26.91-29.88-26.91h-41.6V291.09z"/>
 <path class="st3" d="M501.24,310.57H446.1l-15.52,40.28h-5.45l45.56-118.04h5.94l45.56,118.04h-5.45L501.24,310.57z
     M447.75,306.11h51.67l-25.59-67.03h-0.17L447.75,306.11z"/>
 <path class="st3" d="M580.48,232.81h42.26c34.17,0,48.7,26.74,48.7,59.6c0,33.02-15.68,58.44-49.86,58.44h-41.11V232.81z
     M621.42,346.23c28.56,0,44.57-20.47,44.57-53.82c0-33.35-14.86-54.81-43.42-54.81H585.6v108.63H621.42z"/>
</g>
<g>
 <path class="st3" d="M132.59,528.82c1.16,20.8,15.19,34.5,41.11,34.5c21.46,0,35.33-10.9,35.33-28.07
   c0-18.32-11.89-24.1-39.29-29.06c-24.27-4.46-37.81-11.72-37.81-30.38c0-17.83,15.19-29.39,38.14-29.39
   c24.1,0,37.81,13.37,40.28,33.18h-5.28c-2.31-18-15.19-28.4-34.83-28.4c-20.64,0-33.02,9.74-33.02,24.43
   c0,15.68,11.06,21.46,35,25.92c25.42,4.62,42.1,11.06,42.1,33.35c0,19.65-15.35,33.18-40.45,33.18
   c-30.38,0-45.23-16.84-46.72-39.29H132.59z"/>
 <path class="st3" d="M273.74,448.26h5.12v52.99h75.78v-52.99h5.12V566.3h-5.12v-60.59h-75.78v60.59h-5.12V448.26z"/>
 <path class="st3" d="M407.96,507.36c0-35,22.12-60.92,54.15-60.92c32.03,0,54.48,25.92,54.48,60.92
   c0,34.83-22.45,60.59-54.48,60.59C430.08,567.95,407.96,542.36,407.96,507.36z M511.14,507.36c0-31.2-18.99-56.13-49.03-56.13
   c-30.21,0-48.7,24.76-48.7,56.13c0,31.04,18.49,55.8,48.7,55.8C492.15,563.16,511.14,538.4,511.14,507.36z"/>
 <path class="st3" d="M615.31,448.26l30.21,109.62h0.17l31.04-109.62h5.12L648.33,566.3h-5.61l-30.21-109.62h-0.16L582.46,566.3
   h-5.78l-33.84-118.04h5.28l31.37,109.45h0.16l30.05-109.45H615.31z"/>
</g>
<g>
 <g>
   <path class="st3" d="M201.26,781.89h-72.64c0.5-27.4,19.15-38.8,37.64-49.03c16.84-9.25,30.05-15.52,30.05-34.01
     c0-17-10.9-27.9-29.06-27.9c-19.48,0-30.54,13.37-30.71,31.86h-5.12c0-20.97,14.03-36.49,35.99-36.49
     c21.3,0,34.17,14.03,34.17,32.36c0,21.13-16.01,29.06-33.35,38.63c-16.51,8.92-32.52,18.82-34.01,39.79h67.03V781.89z"/>
   <path class="st3" d="M280.18,725.27c0-35.99,16.34-58.28,40.94-58.28c24.43,0,40.78,21.63,40.78,58.28
     c0,35.49-15.02,58.28-40.78,58.28S280.18,760.76,280.18,725.27z M356.61,725.27c0-33.18-13.87-53.65-35.49-53.65
     s-35.66,20.31-35.66,53.65c0,32.69,13.37,53.65,35.66,53.65C343.57,778.92,356.61,758.12,356.61,725.27z"/>
   <path class="st3" d="M511.31,781.89h-72.64c0.49-27.4,19.15-38.8,37.64-49.03c16.84-9.25,30.05-15.52,30.05-34.01
     c0-17-10.9-27.9-29.06-27.9c-19.48,0-30.54,13.37-30.71,31.86h-5.12c0-20.97,14.03-36.49,35.99-36.49
     c21.3,0,34.17,14.03,34.17,32.36c0,21.13-16.01,29.06-33.35,38.63c-16.51,8.92-32.52,18.82-34.01,39.79h67.03V781.89z"/>
   <path class="st3" d="M661.37,781.89h-72.64c0.49-27.4,19.15-38.8,37.64-49.03c16.84-9.25,30.05-15.52,30.05-34.01
     c0-17-10.9-27.9-29.06-27.9c-19.48,0-30.54,13.37-30.71,31.86h-5.12c0-20.97,14.03-36.49,35.99-36.49
     c21.3,0,34.17,14.03,34.17,32.36c0,21.13-16.01,29.06-33.35,38.63c-16.51,8.92-32.52,18.82-34.01,39.79h67.03V781.89z"/>
 </g>
</g>
<line class="st1" x1="0" y1="183.4" x2="681.84" y2="183.4"/>
<line class="st1" x1="0" y1="617.22" x2="681.84" y2="617.22"/>
<line class="st1" x1="123.01" y1="399.55" x2="805.02" y2="399.55"/>
</svg>
`;

class Splash extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      theme: themes.orange,
      img: imageOptions.communityart,
      video: sample(videoOptions),
    };
    this.changeTheme = this.changeTheme.bind(this);
  }

  componentWillMount() {
    this.changeTheme();
    // setTimeout(() => scroll.scrollToBottom(), 1500);
    scroll.scrollToTop({ duration: 0, delay: 0, smooth: false });
    scroll.scrollToBottom({ duration: 1500, delay: 1500, smooth: true });
  }

  changeTheme() {
    const t = reject(themes, this.state.theme);
    const s = sample(t);
    const it = reject(imageOptions, this.state.img);
    const is = sample(it);
    // const vt = reject(videoOptions, this.state.video);
    // const vs = sample(vt);
    this.setState({ theme: s, img: is });
  }

  render() {
    const { siteName } = this.props;
    const { theme, img, video } = this.state;
    const micaLogo = `
<svg width="90px" height="23px" viewBox="0 0 90 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="micalogo-small">
            <polyline id="Shape" fill="#000000" fill-rule="nonzero" points="32.964 19.196 32.964 15.52 34.602 15.52 34.602 8.125 32.964 8.125 32.964 4.47 42.754 4.47 42.754 8.125 41.115 8.125 41.115 15.52 42.754 15.52 42.754 19.196 32.964 19.196"></polyline>
            <path d="M61.913,11.339 L61.913,11.15 C61.934,9.807 61.513,7.873 59.791,7.873 C57.563,7.873 57.437,10.289 57.437,11.949 C57.437,13.566 57.689,16.046 59.833,16.046 C61.807,16.046 62.144,14.407 61.976,12.789 L66.178,12.789 L66.178,13.481 C66.136,17.81 62.794,19.47 58.846,19.47 C53.908,19.47 50.526,17.033 50.526,11.865 C50.526,7.496 53.236,4.175 57.754,4.175 C59.853,4.175 60.968,4.828 62.186,6.507 L62.228,4.47 L66.219,4.47 L66.219,11.339 L61.913,11.339" id="Shape" fill="#000000" fill-rule="nonzero"></path>
            <polygon id="Shape" fill="#000000" fill-rule="nonzero" points="28.307 22.909 28.96 22.909 28.96 0.77 28.307 0.77"></polygon>
            <g id="Group" transform="translate(46.000000, 0.000000)">
                <g id="Clipped">
                    <mask id="mask-2" fill="white">
                        <polygon points="28.69 22.94 28.69 0.67 0.306 0.67 0.306 22.94"></polygon>
                    </mask>
                    <g id="a"></g>
                    <polygon id="Shape" fill="#000000" fill-rule="nonzero" mask="url(#mask-2)" points="0.306 22.909 0.96 22.909 0.96 0.77 0.306 0.77"></polygon>
                </g>
                <g id="Clipped">
                    <mask id="mask-4" fill="white">
                        <polygon points="28.69 22.94 28.69 0.67 0.306 0.67 0.306 22.94"></polygon>
                    </mask>
                    <g id="a"></g>
                    <polygon id="Shape" fill="#000000" fill-rule="nonzero" mask="url(#mask-4)" points="21.254 23 28.69 0.878 28.071 0.67 20.635 22.791"></polygon>
                </g>
            </g>
            <path d="M5.706,15.52 L7.042,15.52 L7.042,19.196 L0,19.196 L0,15.52 L1.638,15.52 L1.638,8.125 L0,8.125 L0,4.47 L11.092,4.47 C11.491,5.794 11.995,7.075 12.373,8.399 C12.793,7.054 13.318,5.773 13.823,4.47 L23.445,4.47 L23.445,8.125 L21.806,8.125 L21.806,15.52 L23.445,15.52 L23.445,19.196 L14.817,19.196 L14.817,15.52 L16.056,15.52 L16.056,9.106 L12.264,19.196 L9.794,19.196 L5.706,9.337 L5.706,15.52 L5.706,15.52 Z M79.853,8.117 C79.623,9.104 78.848,11.15 78.553,12.117 L81.188,12.117 C80.916,11.13 80.084,9.125 79.853,8.117 L79.853,8.117 Z M80.727,19.196 L80.727,15.52 L82.325,15.52 C82.157,14.954 81.903,14.386 81.756,13.818 L78.008,13.818 C77.861,14.386 77.63,14.954 77.462,15.52 L79.097,15.52 L79.097,19.196 L72.942,19.196 L72.942,15.52 L74.244,15.52 C75.484,11.844 76.681,8.146 77.942,4.47 L84.623,4.47 C85.7723968,8.17095847 86.9765287,11.8546956 88.235,15.52 L90,15.52 L90,19.196 L80.727,19.196 L80.727,19.196 Z" id="Shape" fill="#000000" fill-rule="nonzero"></path>
        </g>
    </g>
</svg>`;
    return (
      <ThemeProvider theme={theme}>
        <Wrapper onClick={this.changeTheme}>
          {/* <LogoWrapper top>
            {siteName && (
              <Logo primary left logoSrc={mgsLogo} siteName={siteName} />
            )}
            <MicaLogo dangerouslySetInnerHTML={{ __html: micaLogo }} />
          </LogoWrapper>
          <LogoWrapper>
            <Logo right primary logoSrc={yearLogo} siteName={siteName} />
          </LogoWrapper> */}

          <GraphicWrapper
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              zIndex: -1,
              // position: "relative",
            }}
          >
            {video && (
              <ReactPlayer
                url={[
                  { src: `assets/${video}.webm`, type: "video/webm" },
                  { src: `assets/${video}_c.mp4`, type: "video/mp4" },
                ]}
                playing
                loop
                muted
                playsinline
                width="100%"
                height="100%"
              />
            )}
          </GraphicWrapper>
          <div style={{ height: "90vh", position: "relative" }}>
            <MicaLogo dangerouslySetInnerHTML={{ __html: logo }} />
          </div>
          <Bg>
            {/* <TestEl /> */}
            {siteName && <Blurb mgsBlock={mgsLogo} siteName={siteName} />}
            <hr style={{ margin: "4rem 0" }} />
            <Footer />
          </Bg>
        </Wrapper>
      </ThemeProvider>
    );
  }
}

Splash.propTypes = {
  siteName: PropTypes.string,
};

export default Splash;



// WEBPACK FOOTER //
// ./src/components/Splash/SplashEl.jsx